import actions from 'modules/booking/view/bookingViewActions';
import viewReducers from 'modules/shared/view/viewReducers';
export default viewReducers(actions);
